// game objects
import { SkyGrid } from "@aceroll/core";

export class Grid extends SkyGrid {
    stickySymbols = new Map();

    respinTriggerCount = null;
    respinCounter = null;

    async playRespinTrigger(_name, count) {
        this.respinTriggerCount = count;
    }

    async updateRespinCounter(count) {
        if (this.respinCounter && this.respinCounter.updateCounter) {
            this.respinCounter.updateCounter(count);
        }
    }

    async playMultiplier(position) {
        const { reel, row } = position;
        const stickySymbol = this.stickySymbols.get(`${reel}-${row}`);
        const symbol = this.symbols[reel][row];

        if (stickySymbol?.multiply) {
            this.symbols[reel][row].visible = false;
            await stickySymbol.multiply();
            this.symbols[reel][row].visible = true;
        } else if (symbol?.multiply) {
            await symbol.multiply();
        }
    }

    async playWin(positions) {
        await super.playWin(positions);
    }

    updateSymbols(initial = false) {
        super.updateSymbols(initial);
    }

    async stick(positions) {
        for (let i = 0; i < positions.length; i++) {
            const { reel, row } = positions[i];

            const symbol = this.symbols[reel][row];

            const stickySymbol = this.getSymbol(symbol.id);

            const { position, size } = this.symbolsTransforms[reel][row];

            stickySymbol.position.set(position.x, position.y);
            stickySymbol.pivot.set(size.width / 2, size.height / 2);
            stickySymbol.setTransforms(this.symbolsTransforms[reel][row]);
            stickySymbol.zIndex = 50;
            this.addChild(stickySymbol);

            this.stickySymbols.set(`${reel}-${row}`, stickySymbol);

            if (!stickySymbol.stick) {
                continue;
            }

            await stickySymbol.stick(this.respinTriggerCount);
            this.respinCounter = stickySymbol;
            this.respinTriggerCount = null;
        }
    }

    unstick(positions) {
        for (let i = 0; i < positions.length; i++) {
            const { reel, row } = positions[i];

            const stickySymbol = this.stickySymbols.get(`${reel}-${row}`);
            stickySymbol.zIndex = stickySymbol.overMask ? 2 : 1;
            this.putSymbol(stickySymbol);
            this.stickySymbols.delete(`${reel}-${row}`);
        }

        this.respinCounter = null;
    }

    unstickAll() {
        this.stickySymbols.forEach(stickySymbol => {
            this.putSymbol(stickySymbol);
        });

        this.stickySymbols.clear();
        this.respinCounter = null;
    }
}